// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled, { type StyledComponent } from '@emotion/styled';
import { primaryTextColour } from '../primary-text-colour';
import { dialogPageTakeoverWidth } from '../style-utils';
import { nowrapEllipsis } from '../nowrap-ellipsis';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled
import type { Theme } from '@emotion/react';
import type { DetailedHTMLProps, HTMLAttributes } from 'react';

// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const EnlargedResultTitleContainer: StyledComponent<
	{
		theme?: Theme;
		as?: React.ElementType;
	} & {
		isCollapsed?: boolean;
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/design-system/no-styled-tagged-template-expression
	},
	DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>,
	{}
	// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
> = styled.div<{
	isCollapsed?: boolean;
}>`
	${nowrapEllipsis}
	line-height: 14px;
	flex: 1 0 auto;
	color: ${primaryTextColour};
	height: 16px;

	@media screen and (max-width: ${dialogPageTakeoverWidth}px) {
		width: 100%;
	}

	width: 90%;
`;
